import React, { useCallback } from "react";
import * as Scrivito from "scrivito";
import NiceModal from "@ebay/nice-modal-react";
import cx from "classnames";
import { useTranslate } from "hooks";

import { Button, Icon, ServicePriceModal } from "components";
import {
  useNodeId,
  useProjectId,
  useSubType,
} from "objs/_ConfiguratorObjs/Wizard/stores/wizardStore";

export const WizardTitleButtons = Scrivito.connect(({ isSidebar = false }) => {
  const translate = useTranslate();
  const nodeId = useNodeId();
  const projectId = useProjectId();
  const subType = useSubType();

  const handleShowPriceBtn = useCallback(() => {
    NiceModal.show(ServicePriceModal, { projectId, nodeId, subType });
  }, [nodeId, projectId, subType]);

  return (
    <div
      className={cx(
        "d-flex align-items-center gap-3",
        isSidebar ? "justify-content-center mt-4" : "justify-content-between",
      )}
    >
      <Button
        data-testid="WizardTitleButtons_show-price-btn"
        onClick={handleShowPriceBtn}
        color="secondary"
        outline={!isSidebar}
        // TODO: forthcoming feature (hidden acc US-19953) hidden with className='d-none'
        className={cx("d-flex align-items-center d-none", {
          "bg-gray-700 text-white": isSidebar,
        })}
        disabled
      >
        <Icon
          iconName="arrows-rotate"
          className="icon-16 me-1 bg-transparent"
        />
        {translate("SHOW_PRICE")}
      </Button>
      {/* TODO: forthcoming feature (hidden acc US-20779) hidden with className='d-none' */}
      <Button
        data-testid="WizardTitleButtons_add-to-project-btn"
        onClick={() => {}}
        color="primary"
        className={cx("d-flex align-items-center d-none", {
          "text-white": isSidebar,
        })}
        disabled
      >
        {translate("ADD_TO_PROJECT")}
      </Button>
    </div>
  );
});
